// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-chip--disabled {\n  opacity: 0.7;\n}\n.theme--light.v-label--is-disabled,\n.theme--light.v-input--is-disabled,\n.theme--light.v-label--is-disabled,\n.theme--light.v-input--is-disabled input,\n.theme--light.v-input--is-disabled textarea {\n  color: rgba(0, 0, 0, 0.6);\n}", ""]);
// Exports
module.exports = exports;
